import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=d18408f4&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=d18408f4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18408f4",
  null
  
)

export default component.exports